
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { OuiIconModule } from 'omnium-ui/icon';
import { FileMetadata } from '../../models/generated/graphql';
import { HistoryDisplayedRecord } from '../../services/historyService';

@Component({
    selector: 'lib-history',
    imports: [MatDialogModule, OuiIconModule],
    templateUrl: './history.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./history.scss']
})
export class HistoryComponent {
  @Input({ required: true }) records: HistoryDisplayedRecord[];

  @Output() documentOpen = new EventEmitter<FileMetadata>();
  @Output() bordereauLink = new EventEmitter<number>();

  constructor() {}

  onFileLinkClick(fileMetadata?: FileMetadata) {
    if (fileMetadata) {
      this.documentOpen.emit(fileMetadata);
    }
  }
  onBordereauLink(bordereauId?: number) {
    if (bordereauId) {
      this.bordereauLink.emit(bordereauId);
    }
  }
}
